import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="work-tabs"
export default class extends Controller {

  static targets = ['panel', 'tab']

  show({ params: { panel } }) {
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle('active', tab.dataset.workTabsPanelParam === panel);
    });

    this.panelTargets.forEach((element) => {
      element.classList.toggle('hidden', element.dataset.workTabsPanel !== panel);
    });
  }
}
